export interface CustomerPickerBehavior {
  hasNoCustomers: boolean
  mustResolveCustomer: boolean
  okText: string
  okDisabled: boolean
  cancelText: string
  hideCancel: boolean
  cancelExits: boolean
}

export interface CustomerAccountMenuBehavior {
  showSwitchAccount: boolean
  canEditCustomer: boolean
}

export function resolveCustomerAccountMenuBehavior(
  customerCount: number,
  hasCurrentCustomer: boolean,
): CustomerAccountMenuBehavior {
  return {
    showSwitchAccount: customerCount > 1 || !hasCurrentCustomer,
    canEditCustomer: hasCurrentCustomer,
  }
}

export function resolveCustomerPickerBehavior(
  customerCount: number,
  selectionRequired: boolean,
  candidateId: number | null,
): CustomerPickerBehavior {
  const hasNoCustomers = customerCount === 0
  const mustResolveCustomer = selectionRequired || hasNoCustomers
  return {
    hasNoCustomers,
    mustResolveCustomer,
    okText: hasNoCustomers ? '退出并返回登录' : '进入',
    okDisabled: !hasNoCustomers && candidateId == null,
    cancelText: mustResolveCustomer ? '退出登录' : '取消',
    hideCancel: hasNoCustomers,
    cancelExits: mustResolveCustomer,
  }
}
